@if (isLoading) {
	<div class="loader">
		<mat-progress-spinner
			class="spinner"
			[diameter]="100"
			[mode]="'indeterminate'"
		></mat-progress-spinner>
	</div>
}
